import { createContext, useContext } from 'react';
import { useTodos } from '@/hooks/useTodos';

type TodosContextValue = ReturnType<typeof useTodos>;

const TodosContext = createContext<TodosContextValue | null>(null);

export function TodosProvider({ children }: { children: React.ReactNode }) {
  const todos = useTodos();
  return <TodosContext.Provider value={todos}>{children}</TodosContext.Provider>;
}

export function useTodosShared(): TodosContextValue {
  const ctx = useContext(TodosContext);
  if (!ctx) throw new Error('useTodosShared must be inside TodosProvider');
  return ctx;
}
